export default __webpack_public_path__ + "static/media/chevron-right.2baba32d.svg";